import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import rstheme from './styles/rstheme.js';
import './api/apiClient';
import './staffView/staffViewSession';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ChakraProvider resetCSS theme={rstheme}>
    <App />
  </ChakraProvider>,
);
